export const errorCode: any = {
  '401': 'Authentication failed, unable to access system resources',
  '403': 'No operation permission',
  '404': 'Resource does not exist',
  default: 'System error, please contact customer service'
};
export default errorCode;
